import {
  AfterContentInit,
  Component,
  ContentChildren,
  Input,
  Output,
  QueryList,
  EventEmitter,
  OnDestroy,
} from '@angular/core';
import { PrTabComponent } from '../pr-tab/pr-tab.component';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'pr-tabs',
    templateUrl: './pr-tabs.component.html',
    styleUrls: ['./pr-tabs.component.scss'],
    standalone: false
})
export class PrTabsComponent implements AfterContentInit, OnDestroy {
  @Input() clazz: string;
  @Input() defaultTextColor: boolean = true;
  @Input() changeTab: BehaviorSubject<any> = new BehaviorSubject(false);
  @ContentChildren(PrTabComponent) tabs: QueryList<PrTabComponent>;
  @Output() lastTab: EventEmitter<boolean> = new EventEmitter();

  // contentChildren are set
  ngAfterContentInit() {
    // get all active tabs
    let activeTabs = this.tabs.toArray().filter(tab => tab.active);

    // if there is no active tab set, activate the first
    if (activeTabs.length === 0) {
      this.selectTab(this.tabs.first);
    }

    this.changeTab.asObservable().subscribe({
      next: code => {
        let tabsArray = this.tabs.toArray();
        let activeTab = tabsArray.filter(tab => tab.active)[0];
        let activeTabIndex = tabsArray.indexOf(activeTab);
        if (code === 'NEXT') this.selectTab(tabsArray[activeTabIndex + 1]);
        if (code === 'FIRST') this.selectTab(tabsArray[0]);
      },
    });
  }

  ngOnDestroy(): void {
    this.changeTab.unsubscribe();
  }

  selectTab(tab: PrTabComponent) {
    // deactivate all tabs
    this.tabs.toArray().forEach(tab => (tab.active = false));

    // activate the tab the user has clicked on.
    tab.active = true;

    let tabIndex = this.tabs.toArray().indexOf(tab);
    this.lastTab.emit(tabIndex === this.tabs.toArray().length - 1);
  }
}
